import { defineRule, configure } from 'vee-validate';
import { required, email } from '@vee-validate/rules';
import { localize } from '@vee-validate/i18n';

// Define the basic rules
defineRule('required', required);
defineRule('email', email);

defineRule('PhoneMinMaxCustom', (value, [min, max], ctx) => {
  // The field is empty so it should pass
  if (!value || !value.length) {
    return true;
  }
  const digitLength = value.match(/\d/g) ? value.match(/\d/g).length : null;
  if(!(digitLength >= min && digitLength <= max)){
    return false;
  }
  return true;
});

defineRule('regex', (value, [pattern]) => {
  if (!value || !value.length) {
    return true;
  }
  const regex = new RegExp(pattern);
  return regex.test(value);
});

configure({
  // Make sure we have a valid form context
  validateOnInput: true,
  // Generates an English message locale generator
  generateMessage: localize('en', {
    messages: {
      required: 'validationMessage.messages.required',
      regex: 'validationMessage.messages.regex',
      is: 'validationMessage.messages.is',
      PhoneMinMaxCustom: 'validationMessage.custom.companyPhoneNumber.PhoneMinMaxCustom'
    },
  }),
});